export default {
  container: {
    backgroundColor: 'white',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8,
  },
  selector: {
    width: 152,
    boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
  },
  selectorMultiple: {
    width: 500,
  },
};
